import { NewsDesignToken } from '../news';
import { RiffDesignTokenV2 } from '../riff';

export const DarkTheme = {
  riff: RiffDesignTokenV2.color.dark,
  news: NewsDesignToken.color.dark,
  palette: {}
} as const;
